import { LetterFileSuggestableField } from "../dto/suggestion.dto";

export enum FormOperationBase {
  LETTER_FILE_NAME = "letterFileName",
  TAGS = "tags",
  DEADLINE = "deadline",
  ARRIVAL_DATE = "arrivalDate",
  COMMENT = "comment",
  CC_USER = "ccUser",
  DOCUMENT = "document",
  DOCUMENT_NAME = "documentName",
  FOLDER = "folder",
  FOLDER_NAME = "folderName",
  FLUX = "flux",
  SAVED_FLUX = "savedFlux",
  UNDRAFT = "undraft",
  NEXT = "next",
  TAKE = "take",
  UNARCHIVE = "unarchive",
  REFRESH = "refresh",
  SIGN_POS = "signPos",
}

export const FormOperation = {
  ...FormOperationBase,
  ...LetterFileSuggestableField,
};
